import { useState, useEffect } from 'react'
import { backendGetRequest } from '../../../../helpers/callBackend'
import InternalPayments from './internalPayments'
import ExternalPayments from './externalPayments'
import Receipts from './receipts'
import { documentTitle } from "../../../../components/header/documentTitle";
import FormattedTabs from '../../../../components/generic/formattedTabs';
import OuterBox from '../../../../components/generic/arpariBoxes/OuterBox'


const Payments = () => {
    const [internalAccountsCountExpected, setInternalAccountsCountExpected] = useState(0)
    const [internalAccountsCountReceived, setInternalAccountsCountReceived] = useState(-1)

    const [loadingInternalAccounts, setLoadingInternalAccounts] = useState(true)
    const [loadingRecipients, setLoadingRecipients] = useState(true)
    const [internalAccounts, setInternalAccounts] = useState([])
    const [recipients, setRecipients] = useState([])
    const [successfulPayments, setSuccessfulPayments] = useState([])
    const [failedPayments, setFailedPayments] = useState([])

    const [last4ToInternalAccountMap, setLast4ToInternalAccountMap] = useState({});

    useEffect(() => {
        documentTitle();
    }, [])

    useEffect(() => {
        if (!internalAccountsCountExpected) return;
        setLoadingInternalAccounts(internalAccountsCountExpected > internalAccountsCountReceived);
    }, [internalAccountsCountExpected, internalAccountsCountReceived]);

    useEffect(() => {
        setLast4ToInternalAccountMap(prevState => {
            const newMapping = {};
            internalAccounts.forEach(account => {
                const last4 = account.account.account_number_last_4;
                if (last4) {
                    newMapping[last4] = account;
                }
            });
            return newMapping;
        });
    }, [internalAccounts]);


    useEffect(() => {
        /* INTERNAL ACCOUNTS */
        backendGetRequest(
            "/api/bank-account/",
            {
                params: {
                    sources: "UN",
                    quick_get: true,
                    page_index: 0,
                },
            }).then((response) => {
                setInternalAccountsCountExpected(response.data.total_pages);
                for (var i = 1; i <= response?.data?.total_pages; i++) {
                    backendGetRequest(
                        "/api/bank-account/",
                        {
                            params: {
                                sources: "UN",
                                quick_get: true,
                                page_index: i,
                            },
                        }).then((response) => {
                            setInternalAccountsCountReceived(prevState => prevState === -1 ? 1 : prevState + 1);
                            setInternalAccounts((prevState) => [
                                ...(prevState || []),
                                ...response?.data?.data,
                            ]);
                        }).catch(() => {
                            setInternalAccountsCountExpected(prevState => prevState - 1);
                        })
                }
            });

        /* COUNTERPARTY INFO */
        backendGetRequest(
            "/api/payments/counterparty/",
            { params: { pageIndex: 0, includeLast4: true, } },
            ""
        ).then((res) => {
            const d = res?.data;

            if (d?.total_pages < 1) return;

            for (let page = 1; page <= d?.total_pages; page++) {
                backendGetRequest(
                    "/api/payments/counterparty/",
                    { params: { pageIndex: page, quick: true, includeLast4: true } },
                    "loadingRecipients"
                ).then((res) => {
                    const d = res?.data;

                    setRecipients((prevState) => {
                        return [...prevState, ...d?.data]
                    })
                    setLoadingRecipients(false)
                })
            }
        })
    }, [])


    const updateReceiptsTable = (newSuccessfulPayments, newFailedPayments) => {

        setSuccessfulPayments((prevState) => {
            return [...newSuccessfulPayments, ...prevState]
        })

        setFailedPayments((prevState) => {
            return [...newFailedPayments, ...failedPayments]
        })
    }

    const addNewRecipientToExternal = (newRecipient) => {
        const newRecipientObject = { id: newRecipient.id, name: newRecipient.retrieved_values.name, nickname: newRecipient.retrieved_values.nickname };

        setRecipients((prevState) => {
            return [...prevState, newRecipientObject]
        })
    }

    const deleteRecipientInExternal = (selectedRecipientId) => {

        setRecipients((prevState) => {
            let updatedRecipients = prevState.filter((recipient) => recipient.id !== selectedRecipientId);
            return updatedRecipients
        })
    }


    const editRecipientInExternal = (updatedRecipient) => {

        setRecipients((prevState) => {
            let prevRecipients = [...prevState];
            let idx = prevRecipients.findIndex((recipient) => recipient.id === updatedRecipient.id);
            prevRecipients[idx].name = updatedRecipient.retrieved_values.name;

            return prevRecipients
        })
    }

    const tabs = [
        {
            "title": "Internal Payments",
            "key": 0,
            "body":
                <InternalPayments
                    internalAccounts={internalAccounts}
                    loadingInternalAccounts={loadingInternalAccounts}
                    updateReceiptsTable={updateReceiptsTable}
                    last4ToInternalAccountMap={last4ToInternalAccountMap}
                />
        },
        {
            "title": "External Payments",
            "key": 1,
            "body": <ExternalPayments
                recipients={recipients}
                loadingRecipients={loadingRecipients}
                internalAccounts={internalAccounts}
                loadingInternalAccounts={loadingInternalAccounts}
                updateReceiptsTable={updateReceiptsTable}
                last4ToInternalAccountMap={last4ToInternalAccountMap}
            />
        },
        {
            "title": "Receipts",
            "key": 2,
            "body": <Receipts
                successfulPayments={successfulPayments}
                failedPayments={failedPayments}
            />,
            "disabled": !(successfulPayments.length + failedPayments.length),
        },
    ]

    return (
        <OuterBox>

            <FormattedTabs
                defaultActiveKey={0}
                tabPanes={tabs}
            />

        </OuterBox>
    )
}

export default Payments